import React from "react";
import { Typography } from "@mui/material";

import { useTranslation } from "react-i18next";

import "./error.css";

export default function NotFoundPage() {
  const { t } = useTranslation() 
  return (
    <div
      className="admin-error"
    >
      <Typography className="code">
        404
      </Typography>
      <Typography className="title">
        {t('pageNotFound')}
      </Typography>
      <Typography className="description">
        {t('pageNotFoundDesc')}
      </Typography>
    </div>
  );
}
